import React from 'react';
import { BrowserRouter as Router, Routes , Route} from 'react-router-dom';
import Home from './Home';
import AboutUs from './AboutUs';
import Faqs from './Faqs';
import ContactUs from './Contact';
import ShippingCost from '../components/ShippingCost';
import Mortgage from '../components/Mortgage';
import TripSplit from '../components/TripSplit';
import CarbonFootprint from '../components/CarbonFootPrint';
import IncomeTax from '../components/IncomeTax';
import Roi from '../components/Roi';
import Emi from '../components/Emi';
import Bmi from '../components/Bmi';
import BreakEvenPoint from '../components/BreakEvenPoint';
import LoanTovalue from '../components/LoanTovalue';
import FuelCost from '../components/FuelCost';
import Tvm from '../components/Tvm';
import InventoryTurnover from '../components/InventoryTurnover';
import Depreciation from '../components/Depreciation';
import Payroll from '../components/Payroll';
import SavingsGoal from '../components/SavingsGoal';
import Retirement from '../components/Retirement';
import Markup from '../components/Markup';
import Gpa from "../components/Gpa";
import CaloriesBurned from "../components/CaloriesBurned";
import ConversionRate from "../components/ConversionRate";
import EventBudget from "../components/EventBudget";
import Lease from "../components/Lease";
import Clv from "../components/Clv";
import EnergyCost from "../components/EnergyCost";
import CompoundInterest from "../components/CompoundInterest";
import InventoryCost from "../components/InventoryCost";
import ProjectCost from "../components/ProjectCost";
import Pension from "../components/Pension";
import HomeAffordability from "../components/HomeAffordability";
import GrossProfitMargin from "../components/GrossProfitMargin";
import WeddingBudget from "../components/WeddingBudget";
import Dti from "../components/Dti";
import FreelanceHourlyRate from "../components/FreelanceHourlyRate";
import CollegeSavings from "../components/CollegeSavings";
import SalesTax from "../components/SalesTax";
import ExpenseRatio from "../components/ExpenseRatio";
import StockProfit from "../components/StockProfit";
import RunningPace from "../components/RunningPace";
import OperatingMargin from "../components/OperatingMargin";
import BodyFatPercentage from "../components/BodyFatPercentage";
import AdvertisingRoi from "../components/AdvertisingRoi";
import EmployeeTurnover from "../components/EmployeeTurnover";
import Productivity from "../components/Productivity";
import BusinessValuation from "../components/BusinessValuation";
import ChurnRate from "../components/ChurnRate";
import Yield from '../components/Yield';
import MarkVSMargin from '../components/MarkVSMargin';
import ConstructionMaterial from '../components/ConstructionMaterial';
import Roa from '../components/Roa';
import WaterFootprint from '../components/WaterFootprint';
import PriceElasticity from '../components/PriceElasticity';
import LoanComparison from '../components/LoanComparison';
import Wip from '../components/Wip';
import EmployeeProductivity from '../components/EmployeeProductivity';
import VehicleDepreciation from '../components/VehicleDepreciation';
import EnvironmentalImpact from '../components/EnvironmentalImpact';
import ProfitAndLoss from '../components/ProfitAndLoss';
import CostBenefitAnalysis from '../components/CostBenefitAnalysis';
import Cpm from '../components/Cpm';
import LandValuation from '../components/LandValuation';
import EnergyEfficiency from '../components/EnergyEfficiency';
import Dso from "../components/Dso";
import EmployeeRetentionRate from "../components/EmployeeRetentionRate"
import OrderFulfillmentCost from "../components/OrderFulfillmentCost"
import SafetyStock from "../components/SafetyStock"
import DefectRate from "../components/DefectRate"
import BurnRate from "../components/BurnRate"
import ReorderPoint from "../components/ReorderPoint"
import LeadScoring from "../components//LeadScoring"
import EmployeeSatisfactionIndex from "../components/EmployeeSatisfactionIndex"
import OvertimePay from "../components/OvertimePay"
import RevenueGrowthRate from "../components/RevenueGrowthRate"
import ProfitPerCustomer from  "../components/ProfitPerCustomer"
import EquipmentDowntime from "../components/EquipmentDowntime"
import TransportationCost from "../components/TransportationCost"
import Nps from "../components/Nps"
import Aht from "../components/Aht"
import WeightLoss from "../components/WeightLoss"
import PatientDosage from '../components/PatientDosage';
import LeadTime from '../components/LeadTime';
import RentalYield from '../components/RentalYield';
import CarbonOffset from '../components/CarbonOffset';
import CostofDebt from '../components/CostOfDebt';
import DiscountedCashFlow from '../components/Dcf';
import CycleTime from '../components/CycleTime';
import ProjectPaybackPeriod from '../components/ProjectPaybackPeriod';
import ChildEducationFund from '../components/ChildEducationFund';
import BreakdownRecovery from '../components/BreakdownRecovery';
import PensionFund from '../components/PensionFund';
import RoiMarketingCampaigns from '../components/RoiMarketingCampaigns';
import WeightConversion from '../components/WeightConversion';
import CashRunway from '../components/CashRunway';
import MachineDowntime from '../components/MachineDowntime';
import Oee from '../components/Oee';
import ProductionCost from '../components/ProductionCost';
import WastePercentage from '../components/WastePercentage';
import CropYield from '../components/CropYield';
import WaterUsageEfficiency from '../components/WaterUsageEfficiency';
import LivestockFeedCost from '../components/LivestockFeedCost';
import FabricConsumption from '../components/FabricConsumption';
import ThreadConsumption from '../components/ThreadConsumption';
import CuttingWaste from '../components/CuttingWaste';
import FootTraffic from '../components/FootTraffic';
import OccupancyCostRatio from '../components/OccupancyCostRatio';
import Cac from '../components/Cac'
import CartAbandonmentRate from '../components/CartAbandonmentRate';
import Dscr from '../components/Dscr';
import TravelBudget from '../components/TravelBudget';
import FlightEmission from '../components/FlightEmission';
import HotelOccupancyRate from '../components/HotelOccupancyRate';
import TouristSpending from '../components/TouristSpending';





function RouterPage() {
  return (
    <div>
      <Router>
        <Routes>

            <Route path="/" exact element={ <Home /> } />
            <Route path="/about-us" element={ <AboutUs /> } />
            <Route path="/faqs" element={ <Faqs /> } />
            <Route path="/contact" element={ <ContactUs /> } />

            <Route path="/shipping-cost-calculator" element = { <ShippingCost />} />
            <Route path="/mortgage-calculator" element = {<Mortgage />} />
            <Route path="/trip-spilt-calculator" element = {<TripSplit />} />
            <Route path="/carbon-foot-print-calculator" element = { <CarbonFootprint /> } />
            <Route path="/income-tax-calculator" element = { <IncomeTax />} />
            <Route path="/return-on-investment-calculator" element = { <Roi /> } />
            <Route path="/equated-monthly-installment-calculator" element = { <Emi /> } />
            <Route path="/body-mass-index-calculator" element = { <Bmi /> } />
            <Route path="/break-even-point-calculator" element = { <BreakEvenPoint /> } />
            <Route path="/loan-to-value-calculator" element={ <LoanTovalue /> } />
            <Route path="/fuel-cost-calculator" element={ <FuelCost /> } />
            <Route path="/time-value-money-calculator" element={ <Tvm /> } />
            <Route path="/inventory-turnover-calculator" element={ <InventoryTurnover />} />
            <Route path="/depreciation-calculator" element={ <Depreciation />} />
            <Route path="/payroll-calculator" element={ <Payroll />} />
            <Route path="/savings-goal-calculator" element={ <SavingsGoal /> } />
            <Route path="/retirement-calculator" element={ <Retirement /> } />
            <Route path="/markup-calculator" element={ <Markup /> } />
            <Route path="/gpa-calculator" element={ <Gpa /> } />
            <Route path="/calories-burned-calculator" element={ <CaloriesBurned /> } />
            <Route path="/conversion-rate-calculator" element={ <ConversionRate /> } />
            <Route path="/event-budget-calculator" element={ <EventBudget /> } />
            <Route path="/lease-calculator" element={ <Lease /> } />
            <Route path="/customer-lifetime-value-calculator" element={ <Clv /> } />
            <Route path="/energy-cost-calculator" element={ <EnergyCost /> } />
            <Route path="/compound-interest-calculator" element={ <CompoundInterest /> } />
            <Route path="/inventory-cost-calculator" element={ <InventoryCost /> } />
            <Route path="/project-cost-calculator" element={ <ProjectCost /> } />

            <Route path="/pension-calculator" element={ <Pension /> } />
            <Route path="/home-affordability-calculator" element={ <HomeAffordability /> } />
            <Route path="/gross-profit-margin-calculator" element={ <GrossProfitMargin /> } />
            <Route path="/wedding-budget-calculator" element={ <WeddingBudget /> } />
            <Route path="/debt-to-income-calculator" element={ <Dti /> } />
            <Route path="/freelance-hourly-rate-calculator" element={ <FreelanceHourlyRate /> } />
            <Route path="/college-savings-calculator" element={ <CollegeSavings /> } />
            <Route path="/sales-tax-calculator" element={ <SalesTax /> } />
            <Route path="/expense-ratio-calculator" element={ <ExpenseRatio /> } />
            <Route path="/stock-profit-calculator" element={ <StockProfit /> } />
            <Route path="/running-pace-calculator" element={ <RunningPace /> } />
            <Route path="/operating-margin-calculator" element={ <OperatingMargin /> } />
            <Route path="/body-fat-percentage-calculator" element={ <BodyFatPercentage /> } />
            <Route path="/advertising-roi-calculator" element={ <AdvertisingRoi /> } />
            <Route path="/employee-turnover-calculator" element={ <EmployeeTurnover /> } />
            <Route path="/productivity-calculator" element={ <Productivity /> } />
            <Route path="/business-valuation-calculator" element={ <BusinessValuation /> } />
            <Route path="/churn-rate-calculator" element={ <ChurnRate /> } />

            <Route path="/yield-calculator" element={ <Yield /> } />
            <Route path="/markup-vs-margin-calculator" element={ <MarkVSMargin /> } />
            <Route path="/construction-material-calculator" element={ <ConstructionMaterial /> } />
            <Route path="/return-on-assets-calculator" element={ <Roa/> } />
            <Route path="/water-foot-print-calculator" element={ <WaterFootprint /> } />
            <Route path="/price-elasticity-demand-calculator" element={ <PriceElasticity /> } />
            <Route path="/loan-comparison-calculator" element={ <LoanComparison /> } />
            <Route path="/work-in-progress-calculator" element={ <Wip /> } />
            <Route path="/employee-productivity-calculator" element={ <EmployeeProductivity /> } />
            <Route path="/vehicle-depreciation-calculator" element={ <VehicleDepreciation /> } />
            <Route path="/environmental-impact-calculator" element={ <EnvironmentalImpact /> } />
            <Route path="/profit-and-loss-calculator" element={ <ProfitAndLoss/> } />
            <Route path="/cost-benefit-analysis-calculator" element={ <CostBenefitAnalysis /> } />
            <Route path="/advertising-cost-per-impression-calculator" element={ <Cpm /> } />
            <Route path="/land-valuation-calculator" element={ <LandValuation /> } />
            {/* <Route path="/land-valuation-calculator" element={ <LandValuation /> } /> */}


            <Route path="/energy-efficiency-calculator" element={ <EnergyEfficiency /> } />
            <Route path="/days-sales-outstanding-calculator" element={ <Dso /> } />
            <Route path="/employee-retention-rate-calculator" element={ <EmployeeRetentionRate /> } />
            <Route path="/order-fulfillment-cost-calculator" element={ <OrderFulfillmentCost /> } />
            <Route path="/safety-stock-calculator" element={ <SafetyStock /> } />
            <Route path="/defect-rate-calculator" element={ <DefectRate /> } />
            <Route path="/burn-rate-calculator" element={ <BurnRate /> } />
            <Route path="/reorder-point-calculator" element={ <ReorderPoint /> } />
            <Route path="/lead-scoring-calculator" element={ <LeadScoring /> } />
            <Route path="/employee-satisfaction-index-calculator" element={ <EmployeeSatisfactionIndex /> } />
            <Route path="/reorder-point-calculator" element={ <ReorderPoint /> } />
            <Route path="/overtime-pay-calculator" element={ <OvertimePay /> } />
            <Route path="/revenue-growth-rate-calculator" element={ <RevenueGrowthRate /> } />
            <Route path="/profit-per-customer-calculator" element={ <ProfitPerCustomer /> } />
            <Route path="/equipment-downtime-calculator" element={ <EquipmentDowntime /> } />
            <Route path="/transportation-cost-calculator" element={ <TransportationCost /> } />
            <Route path="/net-promoter-score-calculator" element={ <Nps /> } />
            <Route path="/average-handle-time-calculator" element={ <Aht /> } />
            <Route path="/weight-loss-calculator" element={ <WeightLoss /> } />


            <Route path="/patient-dosage-calculator" element={ <PatientDosage /> } />
            <Route path="/lead-time-calculator" element={ <LeadTime /> } />
            <Route path="/rental-yield-calculator" element={ <RentalYield /> } />
            <Route path="/carbon-offset-calculator" element={ <CarbonOffset /> } />
            <Route path="/cost-of-debt-calculator" element={ <CostofDebt /> } />
            <Route path="/discounted-cash-flow-calculator" element={ <DiscountedCashFlow /> } />
            <Route path="/cycle-time-calculator" element={ <CycleTime /> } />
            <Route path="/project-payback-period-calculator" element={ <ProjectPaybackPeriod /> } />
            <Route path="/child-education-fund-calculator" element={ <ChildEducationFund /> } />
            <Route path="/breakdown-recovery-calculator" element={ <BreakdownRecovery /> } />
            <Route path="/pension-fund-calculator" element={ <PensionFund /> } />
            <Route path="/roi-for-marketing-campaigns-calculator" element={ <RoiMarketingCampaigns /> } />
            <Route path="/weight-conversion-calculator" element={ <WeightConversion /> } />
            <Route path="/cash-runway-calculator" element={ <CashRunway /> } />
            <Route path="/machine-downtime-calculator" element={ <MachineDowntime /> } />
            <Route path="/overall-equipment-effectiveness-calculator" element={ <Oee /> } />
            <Route path="/production-cost-calculator" element={ <ProductionCost /> } />
            <Route path="/waste-percentage-calculator" element={ <WastePercentage /> } />
            <Route path="/crop-yield-calculator" element={ <CropYield /> } />
            <Route path="/water-usage-efficiency-calculator" element={ <WaterUsageEfficiency /> } />
            <Route path="/livestock-feed-cost-calculator" element={ <LivestockFeedCost /> } />
            <Route path="/fabric-consumption-calculator" element={ <FabricConsumption /> } />
            <Route path="/thread-consumption-calculator" element={ <ThreadConsumption /> } />
            <Route path="/cutting-waste-calculator" element={ <CuttingWaste /> } />

            <Route path="/foot-traffic-calculator" element={ <FootTraffic /> } />
            <Route path="/occupancy-cost-ratio-calculator" element={ <OccupancyCostRatio /> } />
            <Route path="/customer-acquisition-cost-calculator" element={ <Cac /> } />
            <Route path="/cart-abandonment-rate-calculator" element={ <CartAbandonmentRate /> } />
            <Route path="/debt-service-coverage-ratio-calculator" element={ <Dscr /> } />
            <Route path="/travel-budget-calculator" element={ <TravelBudget /> } />
            <Route path="/flight-emission-calculator" element={ <FlightEmission /> } />
            <Route path="/hotel-occupancy-rate-calculator" element={ <HotelOccupancyRate /> } />
            <Route path="/tourist-spending-calculator" element={ <TouristSpending /> } />

        </Routes>
      </Router>
    </div>
  )
}

export default RouterPage
